import SectionHeading from "./SectionHeading";
import { featured } from "@/mocks/trending";
import { categoryName } from "@/mocks/categories";

interface FeaturedProps {
  onOpenCategory: (id: string) => void;
}

export default function Featured({ onOpenCategory }: FeaturedProps) {
  return (
    <section id="focus" className="scroll-mt-24 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <SectionHeading
          eyebrow="Editors' Pick"
          title="焦点瓜料 · 值得细看"
          desc="编辑部精心挑选的深度盘点与专题，不止有爆点，更有值得回味的细节。"
        />

        <div className="grid gap-5 md:grid-cols-3">
          {featured.map((f) => (
            <article key={f.id} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50">
              <a
                href="#stream"
                onClick={() => onOpenCategory(f.categoryId)}
                className="relative block overflow-hidden"
              >
                <img
                  src={f.imageUrl}
                  alt={`吃瓜视频焦点专题：${f.title}`}
                  className="h-52 w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 whitespace-nowrap rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-semibold text-primary-700">
                  {categoryName(f.categoryId)}
                </span>
                <span className="absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 transition-opacity group-hover:opacity-100">
                  <i className="ri-play-fill"></i>
                </span>
              </a>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-extrabold leading-snug text-foreground-950">
                  {f.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{f.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/80 pt-3">
                  <span className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className="ri-pen-nib-line text-xs"></i>
                    </span>
                    {f.author}
                  </span>
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-600">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}